import { createContext } from 'react';

if(typeof(CityGrows.Server.admin) !== 'boolean'){
  throw('CityGrows.Server.admin is not set correctly');
}

const RequestIsGovContext = createContext(CityGrows.Server.admin);

export default RequestIsGovContext;